type ProfileMenuContainerProps = {
	visible?: boolean;
	onClickUrl?: () => void;
	children?: React.ReactChild | React.ReactChild[];
	right?: number;
};
const ProfileMenuContainerInverse: React.FC<ProfileMenuContainerProps> = ({ visible, children, right }) => {
	return (
		<div
			style={{ right: `${right ? right : 0}px` }}
			className={`${
				visible
					? 'profile-menu-container-inverse profile-menu-show'
					: 'profile-menu-container-inverse profile-menu-hide'
			} `}
		>
			<div className="absolute profile-menu">
				<div className="profile-menu-content profile-menu-content-inverse d-flex f-column">{children}</div>
			</div>
			<div className="absolute profile-menu2"></div>
		</div>
	);
};

export default ProfileMenuContainerInverse;
